<template>
  <div :class="`input-comp-container ${noExtraSpacing ? 'no-extra-spacing' : ''} ${error ? 'error' : ''}`">
    <label for="input-comp">
      <span v-if="label" :class="error ? 'error' : ''">
        {{ label }}
      </span>
      <input
        :id="`input-comp-${id}`"
        :disabled="disabled"
        :name="name"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        @input="changeHandler"
        @blur="$emit('blur')"
      />
      <div v-if="error" class="error-label">
        <img :src="publicUrl + '/input-error-icon.svg'" />
        <span>{{ error }}</span>
      </div>
    </label>
  </div>
</template>

<script>
  export default {
    name: "InputComponent",
    props: {
      disabled: {type: Boolean, default: false},
      id: {type: String, required: true},
      value: {type: [String, Number], default: ""},
      type: {type: String, default: "text"},
      name: {type: String, default: "text"},
      placeholder: {type: String, default: ""},
      label: {type: String, default: ""},
      error: {type: String, default: undefined},
      noExtraSpacing: {type: Boolean, default: false}
    },
    data() {
      return {
        publicUrl: process.env.PUBLIC_URL
      }
    },
    methods: {
      changeHandler(e) {
        this.$emit("change-handler", e.target.value)
        this.$emit("input", e.target.value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-comp-container {
    &.error {
      label {
        input[type="number"],
        input[type="text"],
        input[type="email"],
        input[type="password"] {
          border: 2px solid #b00020;
          &:hover,
          &:focus {
            border: 2px solid #b00020;
          }
        }
      }
    }
    &.no-extra-spacing {
      label {
        margin-bottom: 0;
        input[type="number"],
        input[type="text"],
        input[type="email"],
        input[type="password"] {
          margin-top: 0;
        }
      }
    }
    label {
      display: block;
      margin-bottom: 16px;
      input[disabled] {
        background: #f7f4f4;
        cursor: not-allowed;
      }
      span {
        text-align: left;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }

      input[type="number"],
      input[type="text"],
      input[type="email"],
      input[type="password"] {
        font-size: 16px;
        font-weight: 400;
        padding: 8px 12px;
        width: 100%;
        border-radius: 6px;
        margin: 8px 0 0 0;
        border: 1px solid #b9c1bd;
        display: block;
        &:focus {
          border: 1px solid #1ba26f;
        }

        &.error {
          color: #b00020;
          border-color: #b00020;
        }
      }
    }
    .error {
      color: #b00020;
    }
    .error-label {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 14px;
      span {
        color: #b00020;
        font-weight: 600;
        font-size: 14px;
        padding-left: 6px;
      }
      img {
        height: 24px;
        width: 24px;
      }
    }
  }
</style>
